import React, { useEffect, useRef, useState } from "react";
// import Navbar from "../../components/Navbar/Navbar";
import Hero2 from "../../components/hero2/hero2";
import CoupleSection2 from "../../components/CoupleSection2/CoupleSection2";
// import StorySection2 from "../../components/StorySection2/StorySection2";
// import PortfolioSection from "../../components/PortfolioSection";
// import RsvpSection from "../../components/RsvpSection/RsvpSection";
// import BlogSection from "../../components/BlogSection/BlogSection";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";
import VenueSection from "../../components/VenueSection/VenueSection";
import InviteeSection from "../../components/InviteeSection/InviteeSection";
import EventSection4 from "../../components/EventSection4/EventSection4";
import QuoteSection from "../../components/QuoteSection/QuoteSection";
import Hero3 from "../../components/hero3/hero3";
import WeddingDate from "../../components/WeddingDate/WeddingDate";
import BottomSection from "../../components/BottomContainer/BottomContainer";

import RsvpSectionS2 from "../../components/RsvpSectionS2/RsvpSectionS2";
import LetterEnvelope from "../../components/LetterEnvelope/LetterEnvelope";

const ModernChic = () => {
  const containerRef = useRef(null);

  return (
    <div ref={containerRef} className={`fadeInSlow scroll-container`}>
      {/* <Navbar /> */}
      {/* <Hero2 /> */}
      <div className="section">
        <Hero3 />
        <WeddingDate />
      </div>
      <CoupleSection2 />
      <LetterEnvelope />

      {/* <EventSection imageWrapperShape="square" /> */}
      <QuoteSection />
      <EventSection4 haveBackground={true} />
      <VenueSection />
      <RsvpSectionS2 />
      <InviteeSection haveBackground={true} />
      <BottomSection />
      <Footer footerClass={"wpo-site-footer-s2"} />
      <Scrollbar />
    </div>
  );
};

export default ModernChic;
